import users from './users';
import roles from './roles';
import orgUnits from './orgUnits';
import locations from './locations';
import employee from './employee';

const admin = [...users, ...roles, ...orgUnits, ...locations, ...employee];

export default admin;
